// extracted by mini-css-extract-plugin
module.exports = {"card":"DisplayCard_card__1qa8t","icon":"DisplayCard_icon__3xM3u","blue":"DisplayCard_blue__322Av","right":"DisplayCard_right__2Yu1E"};